<template>
  <div class="reconciliation-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth()" :inline="true">
          <el-form-item :label="$t('bike.name98')" prop="ebikeId">
            <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name51')" prop="fenceName">
            <el-input v-model="queryInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name52')" prop="fdbkTitle">
            <el-date-picker
            v-model="searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
          </el-form-item>
      </el-form>
      <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div> <el-button type="primary" size="medium" @click="exportLog">{{ $t('manage.name60') }}</el-button></div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name41')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name53')" prop="fenceName" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name54')" prop="leaveTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.leaveTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name55')" prop="comeTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.comeTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name56')" prop="durationMessage" sortable></el-table-column>
      <el-table-column :label="$t('operate.name9')" width="120px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('operate.name57') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <AppDialog
      size="lg"
      width="90%"
      extra-class="map-trace-dialog"
      :title="$t('operate.name57')"
      :visible.sync="eBikeDetailsDialog"
      v-if="eBikeDetailsDialog"
      :before-close="close"
      @opened="handleTraceDialogOpened"
    >
      <div class="trace-dialog-content clearfix">
        <div style="margin-bottom: 20px">
            <span>
              <span>{{ $t('operate.name72') }}</span>
              <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{ $t('operate.name73') }}</el-radio>
              <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{ $t('operate.name74') }}</el-radio>
            </span>
        </div>
        <div v-if="mapchange==='1'">
          <template>
            <el-form ref="queryForm" :inline="true">
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('operate.name75')">
                    <el-slider v-model="speed" style="width: 200px" :step="1" :min="10"
                               :input="inputspeed(speed)"></el-slider>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item style="float: left">
                    <el-button icon="el-icon-video-play" size="mini" @click="bikePolyLinestart">{{ $t('operate.name76') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template>
          <GmapMap :center='markerPoint' :zoom="googleMapZoom" ref="mapRef" class="map" id="mapps">
            <gmap-marker
              @click="bikePolyLine"
              :position="startmarkerPoint"
              :icon="startmarkericon">
            </gmap-marker>
            <gmap-marker
              :position="endmarkerPoint"
              :icon="endmarkericon">
            </gmap-marker>
          </GmapMap>
        </div>
        <div v-else-if="mapchange==='2'">
          <el-form ref="queryForm" :inline="true">
            <el-row>
              <el-col :span="5">
                <el-form-item :label="$t('operate.name75')">
                  <el-slider v-model="speedbaidu" style="width: 200px" :step="1" :min="10"></el-slider>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item style="float: right">
                  <el-button type="primary" @click="handleQuery">{{ $t('operate.name77') }}</el-button>
                  <el-button type="primary" @click="handPathStop">{{ $t('operate.name78') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <baidu-map class="map" :center="markerPointbaidu" :zoom="20" :scroll-wheel-zoom='true' @ready="handleMap">
              <bm-polyline :path="pathbaidu" stroke-color="#275aff" :stroke-opacity="0.8" :stroke-weight="5"
                           :editing="false"
              ></bm-polyline>
              <bm-marker :position="startmarkerPointbaidu" :icon="startmarkericonbaidu"></bm-marker>
              <bm-marker :position="endmarkerPointbaidu" :icon="endmarkericonbaidu"></bm-marker>
              <bml-lushu
                @stop="reset"
                :speed="speedbaidu*5"
                :path="pathbaidu"
                :icon="icon"
                :play="playbaidu">
              </bml-lushu>
            </baidu-map>
          </template>
        </div>
      </div>
    </AppDialog>
  </div>
</template>
<script>
import { findFenceLogPage, exportFenceLog, locus } from '@/api/operate.js'
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import coordtransform from 'coordtransform'
import { BmlLushu } from 'vue-baidu-map'
import { downloadExcel } from '@/utils/utils'
import AppDialog from '@/components/AppDialog/index.vue'
import { defaultMapChange } from '@/config/flavor'
import { toMapLngLat, resolveInitialZoom } from '@/utils/mapCoords'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    google: gmapApi,
    googleMapZoom () {
      return resolveInitialZoom(this.path.length) || 18
    }
  },
  data() {
    return {
      queryInfo: {
        ebikeId: '',
        fenceName: '',
        endTime: '',
        startTime: '',
        pageSize: 10,
        pageNumber: 1
      },
      searchTime: [],
      tableLoading: false,
      tableList: [],
      total: 0,
      eBikeDetailsDialog: false,
      // 缺省来自 flavor：海外 google('1') / 国内百度('2')；本页暂无天地图
      mapchange: defaultMapChange,
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 15,
      markerPoint: {
        lng: 0,
        lat: 0
      },
      startmarkerPoint: {
        lng: 0,
        lat: 0
      },
      endmarkerPoint: {
        lng: 0,
        lat: 0
      },
      polylinemaker: {
        strokeColor: '#275aff'
      },
      count: 0,
      count2: 0,
      speed: 0,
      startmarkericon: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      endmarkericon: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      bikemarkericon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      path: [],
      bikePath: [
        {
          ebikeId: '',
          cycleId: '',
          dataTime: '',
          lng: '',
          lat: '',
          alt: '',
          speed: ''
        }
      ],
      startMark: {},
      bikespeed: 20,
      play: false,
      startMarkerPoint: {
        lng: '',
        lat: ''
      },
      endMarkerPoint: {
        lng: '',
        lat: ''
      },
      // 百度地图
      icon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      startmarkericonbaidu: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      endmarkericonbaidu: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      markerPointbaidu: {
        lng: 0,
        lat: 0
      },
      startmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      endmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      speedbaidu: 10,
      pathbaidu: [],
      playbaidu: false,
      car_animate: null,
      BMap: null,
      map: null,
      fenceLogId: '',
      markerBlack: null
    }
  },
  components: {
    BmlLushu,
    AppDialog
  },
  created() {
  },
  mounted() {
    this.queryList()
  },
  methods: {
    showDetailsDialog(row) {
      this.fenceLogId = row.fenceLogId
      this.eBikeDetailsDialog = true
    },
    getCycleTraceList() {
      this.path = []
      this.pathbaidu = []
      const data = {
        fenceLogId: this.fenceLogId
      }
      locus(data)
        .then((res) => {
          if (res.code === 200) {
            this.bikePath = res.data.historyList
            if (this.bikePath.length !== 0) {
              if (this.mapchange === '1') {
                this.bikePath.forEach((item) => {
                  if (item.lng && item.lat) {
                    const pt = toMapLngLat(Number(item.lng), Number(item.lat), 'google')
                    if (pt) {
                      this.path.push({ lng: pt.lng, lat: pt.lat })
                    }
                  }
                })
                this.markerPoint.lng = this.path[0].lng
                this.markerPoint.lat = this.path[0].lat
                this.startmarkerPoint.lng = this.path[0].lng
                this.startmarkerPoint.lat = this.path[0].lat
                this.endmarkerPoint.lng = this.path[this.path.length - 1].lng
                this.endmarkerPoint.lat = this.path[this.path.length - 1].lat
                setTimeout(() => {
                  this.bikePolyLine()
                }, 100)
              } else if (this.mapchange === '2') {
                this.bikePath.forEach((item) => {
                  if (item.lng && item.lat) {
                    const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
                    const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
                    this.pathbaidu.push({ lng: Number(bikepointss[0]), lat: Number(bikepointss[1]) })
                  }
                })
                this.markerPointbaidu.lng = this.pathbaidu[0].lng
                this.markerPointbaidu.lat = this.pathbaidu[0].lat
                this.startmarkerPointbaidu.lng = this.pathbaidu[0].lng
                this.startmarkerPointbaidu.lat = this.pathbaidu[0].lat
                this.endmarkerPointbaidu.lng = this.pathbaidu[this.pathbaidu.length - 1].lng
                this.endmarkerPointbaidu.lat = this.pathbaidu[this.pathbaidu.length - 1].lat
              }
            }
          }
        })
        .catch(() => {})
    },
    getDataList() {
      this.tableLoading = true
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      this.queryInfo.ebikeId = (this.queryInfo.ebikeId || '').trim()
      if (this.searchTime) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.searchTime)
        this.queryInfo.startTime = startTime
        this.queryInfo.endTime = endTime
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
      findFenceLogPage(this.queryInfo)
        .then(res => {
          this.tableList = res.data.fenceLogPage.records
          this.total = res.data.fenceLogPage.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },
    resetQuery() {
      this.queryInfo = {
        ebikeId: '',
        fenceName: '',
        endTime: '',
        startTime: '',
        pageSize: 10,
        pageNumber: 1
      }
      this.searchTime = []
      this.queryList()
    },
    exportLog() {
      this.tableLoading = true
      if (this.searchTime) {
        // 日期时间范围转账号时区查询参数
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.searchTime)
        this.queryInfo.startTime = startTime
        this.queryInfo.endTime = endTime
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
      exportFenceLog(this.queryInfo).then(res => {
        downloadExcel(res, this.$t('operate.name202'))
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    close() {
      this.eBikeDetailsDialog = false
    },
    handleTraceDialogOpened() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.getCycleTraceList()
          this.resizeTraceMap()
        }, 150)
      })
    },
    resizeTraceMap() {
      if (this.mapchange === '1' && this.$refs.mapRef) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          if (this.google && this.google.maps) {
            this.google.maps.event.trigger(map, 'resize')
            if (this.markerPoint.lng) {
              map.setCenter(this.markerPoint)
            }
          }
        }).catch(() => {})
      } else if (this.mapchange === '2' && this.map) {
        this.map.checkResize && this.map.checkResize()
      }
    },
    stratbikemaker () {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.markerBlack = new this.google.maps.Marker({
          position: this.path[0],
          icon: this.bikemarkericon
        })
        this.markerBlack.setMap(map)
      })
    },
    inputspeed (speed) {
      this.speed = speed
    },
    mapchangeradio() {
      this.getCycleTraceList()
    },
    bikePolyLine () {
      var lineSymbol = {
        path: this.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        fillColor: '#FFF',
        strokeColor: '#FFF',
        scale: 0.9,
        strokeWeight: 3,
        fillOpacity: 0.8
      }
      this.stratbikemaker()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.flightPath = new this.google.maps.Polyline({
          path: this.path,
          strokeColor: '#275aff',
          icons: [{
            icon: lineSymbol,
            offset: '0',
            repeat: '5%'
          }],
          strokeOpacity: 0.8,
          strokeWeight: 10
        })
        this.flightPath.setMap(map)
      })
    },
    bikePolyLinestart () {
      clearInterval(this.car_animate)
      this.car_animate = setInterval(() => {
        this.markerBlack.setIcon(this.bikemarkericon)
        this.markerBlack.setPosition(this.path[this.count])
        this.count += 1
        this.count2 = this.count
        if (this.count === this.path.length) {
          this.markerBlack.setPosition(this.path[this.path.length - 1])
          this.count2 = 0
          this.count = 0
          clearInterval(this.car_animate)
        }
      }, (1 / this.speed) * 7000)
    },
    reset () {
      this.playbaidu = false
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      this.getCycleTraceList()
      console.log('Bmap====', BMap)
    },
    handleQuery () {
      this.playbaidu = true
      if (this.mapchange === '2') {
        this.markerPointbaidu.lng = 0
        this.markerPointbaidu.lat = 0
        setTimeout(() => {
          this.map.setZoom(20)
          this.markerPointbaidu.lng = this.pathbaidu[0].lng
          this.markerPointbaidu.lat = this.pathbaidu[0].lat
          this.markerPointbaidu = { lng: this.markerPointbaidu.lng, lat: this.markerPointbaidu.lat }
        }, 100)
      }
    },
    handPathStop () {
      this.playbaidu = false
    },
    handleClose() {
      this.detailsDialog = false
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.reconciliation-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .trace-dialog-content {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
  .map {
    width: 100%;
    height: 600px;
    min-height: 400px;
  }
}
</style>
